import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import CreateVillaModal from "../components/CreateVillaModal";
import EditVillaModal from "../components/EditVillaModal";
import api from '../config/api';

export default function VillaManagement() {
  const [villas, setVillas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedVilla, setSelectedVilla] = useState(null);


  const fetchVillas = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(api("/villas"), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setVillas(data);
    } catch (error) {
      console.error("Error fetching villas:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVillas();
  }, []);

  const handleEdit = (villa) => {
    setSelectedVilla(villa);
    setShowEditModal(true);
  };
  

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <div className="layout-page">
          <Navbar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <h2 className="mb-4">Villa Management</h2>
              <div className="card">
                <div className="card-body table-responsive">
                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Location</th>
                          <th>Description</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {villas.map((villa) => (
                          <tr key={villa.id}>
                            <td>{villa.name}</td>
                            <td>{villa.location || "-"}</td>
                            <td>{villa.description || "-"}</td>
                            <td>
                              <span className={`badge ${villa.is_active ? "bg-success" : "bg-secondary"}`}>
                                {villa.is_active ? "Active" : "Inactive"}
                              </span>
                            </td>
                            <td>
                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => handleEdit(villa)}
                                title="Edit"
                              >
                                <i className="bx bx-edit-alt"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => alert("Delete belum diimplementasi")}
                                title="Delete"
                              >
                                <i className="bx bx-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>

              {/* Floating Create Button */}
              <button className="fab" onClick={() => setShowCreateModal(true)}>
                <span className="icon">+</span>
                <span className="label">Add Villa</span>
              </button>

              {/* Create Modal */}
              <CreateVillaModal
                show={showCreateModal}
                onClose={() => setShowCreateModal(false)}
                onSuccess={fetchVillas}
              />
              <EditVillaModal
                show={showEditModal}
                onClose={() => setShowEditModal(false)}
                onSuccess={fetchVillas}
                villa={selectedVilla}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
